'use client';

import type { FC, PropsWithChildren } from 'react';
import { ToastContainer } from 'react-toastify';
import useBreakpoints from '@/ui/hooks/use-breakpoints';

import 'react-toastify/dist/ReactToastify.css';
import $ from './Toast.module.scss';

const ToastProvider: FC<PropsWithChildren> = ({ children }) => {
  const { isPhone } = useBreakpoints();

  return (
    <>
      {children}
      <ToastContainer
        position={isPhone ? 'bottom-center' : 'bottom-right'}
        toastClassName={$.toast}
        limit={5}
      />
    </>
  );
};

export default ToastProvider;
